export const scrollToTop = () => document.body.scrollTo(0, 0);
